import { render, staticRenderFns } from "./FingerprintIdentification.vue?vue&type=template&id=73b3e7cc&"
import script from "./FingerprintIdentification.vue?vue&type=script&lang=js&"
export * from "./FingerprintIdentification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports